import React, { Fragment } from 'react';
import { useTranslator, useCurrentLanguage } from 'tradera-lang';
import { formatPrice } from '@tradera/blueprint/utils';
import Flag from 'tradera-components/flag/flag';

const ShippingDisplay = ({
    buyerCountryCode,
    shippingOptions,
    preferredCurrency
}) => {
    const { t } = useTranslator();
    const { language } = useCurrentLanguage();

    // TODO: Remove the "x kr" or "x SEK" in backend instead
    const removeCostInShippingOption = option =>
        option.replace(/\s*\d+\s*kr$/, '').replace(/\s*\d+\s*SEK$/, '');

    const isSwedishBuyer = buyerCountryCode === 'SE';
    let displayOptions = shippingOptions;
    if (buyerCountryCode !== undefined && !isSwedishBuyer) {
        displayOptions = [
            ...displayOptions.filter(
                option => option.toCountryCodeIso2 === buyerCountryCode
            ),
            ...displayOptions.filter(option => option.isTakeaway)
        ];
    }

    return (
        <Fragment>
            <div className="row my-5 d-none d-md-block">
                <div className="col-12 d-flex">
                    <div className="flex-grow-1 mr-4">
                        <span className="h4 text-styled">
                            {t('checkout_bin_shippingOptions')}:
                        </span>
                    </div>
                    <div className="d-flex flex-column">
                        {displayOptions.map((ship, index) => {
                            const description = removeCostInShippingOption(
                                ship.displayText
                            );
                            return (
                                <div
                                    key={description + ship.cost}
                                    className={`d-flex ${
                                        index === displayOptions.length - 1
                                            ? ''
                                            : 'mb-2'
                                    }`}>
                                    {!isSwedishBuyer && (
                                        <Flag
                                            className="icon icon-lg mr-2 align-middle"
                                            countryCodeIso2={
                                                ship.toCountryCodeIso2
                                            }
                                        />
                                    )}
                                    <div className="flex-grow-1 mr-5">
                                        {description}
                                    </div>
                                    <div className="ml-4 font-weight-bold">
                                        {formatPrice(
                                            ship.cost,
                                            language,
                                            preferredCurrency
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            <div className="row my-4 d-block d-md-none">
                <div className="col-12">
                    <span className="m-0 h4 text-styled">
                        {t('checkout_bin_shippingOptions')}:
                    </span>
                </div>
            </div>
            {displayOptions.map((ship, index) => {
                const description = removeCostInShippingOption(
                    ship.displayText
                );
                return (
                    <div
                        key={description + ship.cost}
                        className={`row d-md-none ${
                            index === displayOptions.length - 1
                                ? 'mb-4'
                                : 'mb-2'
                        }`}>
                        <div className="col-12 d-flex justify-content-between">
                            <div className="flex-grow-1 d-flex align-items-center">
                                {!isSwedishBuyer && (
                                    <Flag
                                        className="icon icon-lg mr-2 align-middle"
                                        countryCodeIso2={ship.toCountryCodeIso2}
                                    />
                                )}
                                <span>{description}</span>
                            </div>
                            <div>
                                {formatPrice(
                                    ship.cost,
                                    language,
                                    preferredCurrency
                                )}
                            </div>
                        </div>
                    </div>
                );
            })}
        </Fragment>
    );
};

export default ShippingDisplay;
